import { communityChannel, communityPage } from '~publish/legacy/routes'
import { withCopiedSearchParams } from '~publish/legacy/routes/helpers/withCopiedSearchParams'

/**
 * Matched to `UNREPLIED_COMMENTS_LOOKBACK_DAYS` in `core-modules`, so Community
 * opens on the range the takeaway counted. Only the comment list reads it: the
 * by-post view queries without a date range, and which of the two Community
 * opens is the customer's saved preference rather than something a link sets.
 */
const COMMENT_LOOKBACK = 'last30days'

/**
 * Where the `engageAudience` CTA opens Community.
 *
 * No takeaway in this category names a post or a comment — only `repostPost`
 * carries a `postId` — so the destination is an inbox, not a thread. The
 * channels the takeaway names therefore decide it: one channel has its own
 * Community view, and several need the all-channels view filtered to that set,
 * because no single channel's inbox holds what the takeaway counted.
 *
 * The page rendering the card does not enter into it. The CTA action names a
 * destination, not the category or the surface that chose it.
 */
export function getEngageAudienceRoute(
  /** Channels the takeaway names, as `Takeaway.channelIds` returns them. */
  channelIds: ReadonlyArray<string>,
): string {
  const [firstChannelId] = channelIds

  if (channelIds.length === 1 && firstChannelId) {
    return withCopiedSearchParams(
      communityChannel.getRoute({
        channelId: firstChannelId,
        // Insights and Community do not share query params, so carrying this
        // page's over would apply filters the actor never chose in Community.
        copiedSearchParams: [],
      }),
      [],
      [['publishedAt', COMMENT_LOOKBACK]],
    )
  }

  return communityPage.getRoute({ channelIds: [...channelIds] })
}
